
















































import Vue from 'vue'
import ConfirmDialog from '@/components/elements/ConfirmDialog.vue'
import { CarouselElInterface, CarouselImage } from '@/config/interfaces'

export default Vue.extend({
  name: 'CarouselEl',

  components: { ConfirmDialog },

  props: {
    templateItemData: {
      type: Object as () => CarouselElInterface,
      required: true
    }
  },

  data: () => ({
    showPopup: false,
    selectedImage: {}
  }),

  methods: {
    getImageSize (image: CarouselImage): string {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return image.smallUrl
        case 'sm': return image.smallUrl
        case 'md': return image.mediumUrl
        case 'lg': return image.mediumUrl
        default: return image.largeUrl
      }
    },

    goToUri (image: CarouselImage) {
      if (Object.prototype.hasOwnProperty.call(image, 'confirmDialog')) {
        this.selectedImage = image
        this.showPopup = true

        return
      }

      this.getView(image.view, image.uri)
    }
  }
})
